import { useUserContext } from '../utils/userContext';
import { useEffect } from 'react';
import '../styles/adminStyles.css';

function Customer() {
    const { usersTotal, fetchUsers, fetchUserStats, invoiceStats } = useUserContext();

    useEffect(() => {
        fetchUsers(true);
        fetchUserStats();
    }, [fetchUsers, fetchUserStats]);

    const invoiceLength = invoiceStats.map(invoice => invoice.count).reduce((a, b) => a + b, 0);

    return (
        <>
            <div className='pageContainer'>
                <h1>Dashboard</h1>
                <div style={{display: 'flex', gap: '100px', flexWrap: 'wrap'}}>
                    <div className='adbStatCard'>
                        <h3>Anzahl der User: {usersTotal}</h3>
                    </div>
                    <div className='adbStatCard'>
                        <h3>Anzahl der Rechnungen: {invoiceLength}</h3>
                    </div>
                    <div className='adbStatCard'>
                        <h3>Termine: Keine Termine</h3>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Customer;